import React, {useEffect} from "react"
import {useTranslation} from "react-i18next";
import {Box, Button, CssBaseline, Grid, Typography} from "@mui/material";
import CustomNavbar from "../components/CustomNavbar";
import LeftNavigation from "../components/LeftNavigation";
import RightLogo from "../components/RightLogo";
import Footer from "../components/Footer";
import {MAIN_COLOR_BLUE} from "../utils/styles";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import {useNavigate} from "react-router-dom";
import {useAppDispatch} from "../store/store";
import {changePage, getUserLocation, sendEventsData} from "../store/actions/actions";
import {browserName, deviceType, osName} from 'react-device-detect';
import {useSelector} from "react-redux";
import {getCurrentLanguage} from "../utils/Helpers";

const HomePage = () => {
    const {t, i18n} = useTranslation('home-page')
    const dispatch = useAppDispatch();
    const location = useSelector((state:any)=> state.app.location)
    let key = getCurrentLanguage(i18n);

    useEffect(() => {
        dispatch(getUserLocation())
    });

    useEffect(() => {
        if(location){
            dispatch(sendEventsData({
                        date: new Date().toLocaleString(),
                        timestamp: new Date().getTime(),
                        value: location.city,
                        type: "city"
            }))
            dispatch(sendEventsData({
                date: new Date().toLocaleString(),
                timestamp: new Date().getTime(),
                value: location.country,
                type: "country"
            }))
        }
    }, [dispatch,location]);

    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value: deviceType,
            type: "device"
        }))

        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value: browserName,
            type: "browser"
        }))
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value: osName,
            type: "os"
        }))
    },[dispatch]);

    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value: "/home",
            type: "pageView"
        }))
    }, [dispatch]);


    const navigate = useNavigate();

    const handleNavigation = () => {
        dispatch(changePage(1) as any)
        navigate("/simulation")
    }
    return (
        <React.Fragment>
            <CssBaseline/>
            <CustomNavbar/>
            <Grid container style={{marginTop: 8}} spacing={3}>
                <Grid item xs={2}>
                    <LeftNavigation/>
                </Grid>
                <Grid item xs={8} style={{
                    textAlign: "center",
                    justifyContent: "center"
                }}>
                    <Typography variant="body2" fontWeight="bold" color={MAIN_COLOR_BLUE}>
                        {t('general.tum' as any)}
                    </Typography>
                    <Typography style={{marginTop: 16, padding: 16, fontWeight: "bold"}} variant="h3" gutterBottom>
                        {t("home_page.title" as any)}
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom>
                        {t("home_page.subtitle" as any)}
                    </Typography>
                    <br/>
                    <Typography paragraph>
                        {t("home_page.subtitle2" as any, {sub:"\u2082"})}
                    </Typography>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box
                                style={{marginTop: 16}}
                                component="img"
                                src={require("../assets/pages/home/"+key+"/home_page.png")}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item sm={12}>
                            <Box display="flex" justifyContent="flex-end">
                                <Button
                                    disableRipple={true}
                                    sx={{
                                        backgroundColor: MAIN_COLOR_BLUE,
                                        color: "white",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        padding: "10px 10px",
                                        '&:hover': {
                                            background: MAIN_COLOR_BLUE
                                        },
                                    }}
                                    onClick={handleNavigation}
                                >
                                    <PlayCircleOutlineIcon sx={{mr: "10px"}}/>
                                    {t('home_page.button' as any)}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={2}>
                    <RightLogo/>
                </Grid>
            </Grid>
            <Footer/>
        </React.Fragment>
    )
}
export default HomePage
